"use client";

import { useState, useRef, useEffect } from "react";
import { Label } from "../../../../components/tailwind_componentes/Label";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../components/tailwind_componentes/Card";
import {
  DialogHeader,
  DialogFooter,
} from "../../../../components/tailwind_componentes/Dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../components/tailwind_componentes/Select";
import { TooltipProvider } from "../../../../components/tailwind_componentes/Tooltip";
import { makeRequest } from "../../../../assets/functions_helper";
import { CloseButton, SendButton } from "../../../../components/buttons";
import { Box } from "@mui/material";
import { openDB } from "idb";
import {
  CustomDialog,
  CustomDialogContent,
  CustomDialogTitle,
} from "../../../../components/customDialog";
import { useNavigate } from "react-router-dom";

// Configuración de la base de datos (Lógica sin cambios)
const setupDatabase = async () => {
  return openDB("MenuColorsDB", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("colors")) {
        db.createObjectStore("colors", { keyPath: "menuId" });
      }
    },
  });
};

// Guardar el color de un menú en IndexedDB (Lógica sin cambios)
const saveMenuColor = async (menuId, color) => {
  const db = await setupDatabase();
  await db.put("colors", { menuId, color });
};

// Obtener el color de un menú desde IndexedDB (Lógica sin cambios)
const getMenuColor = async (menuId) => {
  const db = await setupDatabase();
  const storedColor = await db.get("colors", menuId);

  if (storedColor) {
    return storedColor.color;
  }

  const newColor =
    colorPalette[Math.floor(Math.random() * colorPalette.length)];
  await saveMenuColor(menuId, newColor);
  return newColor;
};

// Tu arreglo de colores predefinidos (Se mantienen para las celdas)
const colorPalette = [
  "#E63946", // Red
  "#457B9D", // Blue
  "#2A9D8F", // Teal
  "#F4A261", // Orange
  "#264653", // Dark navy
  "#8D99AE", // Gray-blue
  "#D62828", // Bright red
  "#118AB2", // Bright blue
  "#06D6A0", // Green
  "#FFB703"  // Yellow
];

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

// ******************************************************
// CAMBIO EN TutorialAnimation: Adaptación de la animación al tema claro
// ******************************************************
function TutorialAnimation() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setStep((prevStep) => (prevStep + 1) % 7);
    }, 2000);
    return () => clearInterval(timer);
  }, []);

  const menus = [
    { name: "Desayuno", color: "#FF9999" },
    { name: "Almuerzo", color: "#99FF99" },
    { name: "Cena", color: "#9999FF" },
  ];

  return (
    // CAMBIO: Fondo claro para la animación, texto oscuro
    <div className="relative w-full h-48 bg-gray-100 rounded-lg overflow-hidden border border-gray-300">
      <style jsx>{`
        @keyframes dropdownAppear {
          0% {
            opacity: 0;
            transform: translateY(-10px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes optionSelect {
          0%,
          100% {
            background-color: transparent;
          }
          // CAMBIO: Color de fondo en hover/select para tema claro (gris oscuro semitransparente)
          50% {
            background-color: rgba(0, 0, 0, 0.05); 
          }
        }
        @keyframes cellPaint {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        @keyframes arrowMove {
          0% {
            transform: translate(0, 0) rotate(-45deg);
          }
          50% {
            transform: translate(2px, 2px) rotate(-45deg);
          }
          100% {
            transform: translate(0, 0) rotate(-45deg);
          }
        }
        @keyframes arrowClick {
          0%,
          100% {
            transform: scale(1) rotate(-45deg);
          }
          50% {
            transform: scale(0.8) rotate(-45deg);
          }
        }
        .dropdown {
          animation: dropdownAppear 0.5s ease-out;
        }
        .option {
          transition: background-color 0.3s ease;
        }
        // CAMBIO: Estilo hover en opción
        .option:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }
        .cell {
          transition: background-color 0.3s ease;
        }
        .arrow {
          position: absolute;
          width: 16px;
          height: 16px;
          // CAMBIO: Flecha en color oscuro para el fondo claro
          background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/></svg>'); 
          background-size: contain;
          transform: rotate(-45deg);
          pointer-events: none;
          z-index: 10;
          transition: all 0.5s ease;
        }
      `}</style>
      <div className="p-2">
        <div className="dropdown mb-2">
          {/* CAMBIO: Botón de selección claro con texto oscuro */}
          <div className="bg-white border border-gray-300 p-1 rounded cursor-pointer text-xs text-gray-800">
            Seleccionar un Menu
          </div>
          {step >= 1 && (
            // CAMBIO: Menú desplegable claro con borde
            <div className="mt-1 bg-white border border-gray-300 rounded overflow-hidden shadow-md">
              {menus.map((menu, index) => (
                <div
                  key={menu.name}
                  className={`option p-1 flex items-center text-xs text-gray-800 ${
                    // CAMBIO: Estilo de selección
                    step >= 2 && index === 1 ? "bg-gray-200" : ""
                    }`}
                >
                  <div
                    className="w-3 h-3 rounded-full mr-1"
                    style={{ backgroundColor: menu.color }}
                  ></div>
                  <span>{menu.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="grid grid-cols-7 gap-0.5">
          {Array.from({ length: 35 }).map((_, index) => (
            <div
              key={index}
              // CAMBIO: Celdas base en gris claro
              className={`cell h-6 rounded ${(step >= 4 && index === 8) ||
                  (step >= 5 && index >= 8 && index <= 13)
                  ? "animate-[cellPaint_0.5s_ease-in-out_forwards]"
                  : "bg-gray-200"
                }`}
              style={{
                backgroundColor:
                  (step >= 4 && index === 8) ||
                    (step >= 5 && index >= 8 && index <= 13)
                    ? menus[1].color
                    : undefined,
              }}
            ></div>
          ))}
        </div>
      </div>
      <div
        className="arrow"
        style={{
          left:
            step === 0
              ? "10px"
              : step === 1
                ? "20px"
                : step === 2
                  ? "20px"
                  : step === 3
                    ? "60px"
                    : step >= 4
                      ? `${60 + (step - 4) * 90}px`
                      : "60px",
          top:
            step === 0
              ? "10px"
              : step === 1
                ? "40px"
                : step === 2
                  ? "70px"
                  : step >= 3
                    ? "130px"
                    : "70px",
          animation:
            step === 2 || step === 4 || step === 5
              ? "arrowClick 0.5s"
              : "arrowMove 1s infinite",
        }}
      ></div>
    </div>
  );
}
// ******************************************************
// FIN CAMBIO TutorialAnimation
// ******************************************************

// Lógica de datos y funciones (Sin cambios)
// ... [setupDatabase, saveMenuColor, getMenuColor, colorPalette, daysOfWeek, transformDataByMenu, reverseTransformData] ...
// Las funciones que no tienen cambios de lógica se omiten aquí por brevedad, pero se mantienen igual en el archivo original.


export default function WeeklyMenuScheduler({ restaurantId }) {
  const [menus, setMenus] = useState();
  const [schedules, setSchedules] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [rangeStart, setRangeStart] = useState(null);
  const [hoveredCell, setHoveredCell] = useState(null);
  const [clearMode, setClearMode] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [showTutorial, setShowTutorial] = useState(
    () => !localStorage.getItem("tutorialShown")
  );
  const scheduleGridRef = useRef(null);
  const navigate = useNavigate();
  const closeTutorial = () => {
    localStorage.setItem("tutorialShown", "true");
    setShowTutorial(false);
  };

  // Lógica de useEffect (Sin cambios)
  useEffect(() => {
    const fetchMenusWithColors = async () => {
      try {
        const response = await makeRequest(
          "GET",
          `menu_manager/view?restaurant_id=${restaurantId}`,
          null,
          "application/json",
          localStorage.getItem("token"),
          localStorage.getItem("tokenType"),
          () => {
            navigate("/login");
          }
        );

        console.log(response);

        const updatedResponse = (
          await Promise.all(
            response["items"].map(async (menu) => {
              const color = await getMenuColor(menu.id);
              return { ...menu, color };
            })
          )
        ).filter((menu) => menu.is_active);

        setMenus(updatedResponse);
        const schedulesTransformed = reverseTransformData(updatedResponse);
        setSchedules(schedulesTransformed);
        setLoading(true);
      } catch (error) {
        console.log("Error al obtener los menús:", error);
      }
    };

    if (restaurantId) {
      fetchMenusWithColors();
    }
  }, [navigate, restaurantId]);

  // Lógica de funciones de transformación, manejo de clicks y guardado (Sin cambios)
  const transformDataByMenu = (data, timezone) => {
    const groupedByMenu = {};

    data.forEach((item) => {
      const { menuId } = item;
      if (!groupedByMenu[menuId]) {
        groupedByMenu[menuId] = {
          id: menuId,
          schedule: {
            days: [],
            timezone: timezone,
          },
        };
      }
      Object.keys(item).forEach((key) => {
        if (key !== "menuId") {
          let { startTime, endTime } = item[key];
          if (endTime === "24:00") {
            endTime = "23:59";
          }
          let dayEntry = groupedByMenu[menuId].schedule.days.find(
            (d) => d.day === key
          );
          if (!dayEntry) {
            dayEntry = { day: key, times: [] };
            groupedByMenu[menuId].schedule.days.push(dayEntry);
          }
          dayEntry.times.push({
            start_time: startTime,
            end_time: endTime,
          });
        }
      });
    });

    Object.values(groupedByMenu).forEach((menu) => {
      menu.schedule.days = menu.schedule.days.filter(
        (day) => day.times.length > 0
      );
    });

    return Object.values(groupedByMenu);
  };

  const reverseTransformData = (data) => {
    const result = [];
    data
      .filter(
        (menu) =>
          menu.schedule &&
          Array.isArray(menu.schedule.days) &&
          menu.schedule.days.length > 0
      )
      .forEach((menu) => {
        menu.schedule.days.forEach((day) => {
          if (day.times.length > 0) {
            day.times.forEach((time) => {
              result.push({
                menuId: menu.id,
                [day.day]: {
                  startTime: time.start_time,
                  endTime: time.end_time,
                },
              });
            });
          }
        });
      });
    return result;
  };

  const handleMenuSelect = (menuId) => {
    const menu = menus.find((m) => m.id.toString() === menuId);
    setSelectedMenu(menu);
    setRangeStart(null);
    setClearMode(false);
  };

  const getScheduleStyle = (day, hour) => {
    const time = `${hour.toString().padStart(2, "0")}:00`;
    const relevantSchedules = schedules.filter(
      (schedule) =>
        schedule[day] &&
        schedule[day].startTime <= time &&
        schedule[day].endTime > time
    );

    if (relevantSchedules.length > 0) {
      const menu = menus.find((m) => m.id === relevantSchedules[0].menuId);
      return { backgroundColor: menu.color };
    }

    return {};
  };

  const isRangeOverlapping = (startDay, endDay, startHour, endHour) => {
    for (
      let d = Math.min(startDay, endDay);
      d <= Math.max(startDay, endDay);
      d++
    ) {
      const currentDay = daysOfWeek[d];
      for (let h = startHour; h <= endHour; h++) {
        if (isCellPainted(currentDay, h)) {
          return true;
        }
      }
    }
    return false;
  };

  const handleCellClick = (day, hour) => {
    if (!selectedMenu) return;

    if (!rangeStart) {
      setRangeStart({ day, hour });
      if (
        isCellPainted(day, hour) &&
        schedules.some((s) => s[day] && s.menuId === selectedMenu.id)
      ) {
        setClearMode(true);
      }
    } else {
      const startDay = daysOfWeek.indexOf(rangeStart.day);
      const endDay = daysOfWeek.indexOf(day);
      const startHour = Math.min(rangeStart.hour, hour);
      const endHour = Math.max(rangeStart.hour, hour);

      if (clearMode) {
        setSchedules((prevSchedules) =>
          prevSchedules.filter((schedule) => {
            if (schedule.menuId !== selectedMenu.id) return true;
            for (
              let d = Math.min(startDay, endDay);
              d <= Math.max(startDay, endDay);
              d++
            ) {
              const currentDay = daysOfWeek[d];
              if (schedule[currentDay]) {
                const scheduleStart = parseInt(
                  schedule[currentDay].startTime.split(":")[0]
                );
                const scheduleEnd = parseInt(
                  schedule[currentDay].endTime.split(":")[0]
                );
                if (scheduleStart < endHour + 1 && scheduleEnd > startHour) {
                  return false;
                }
              }
            }
            return true;
          })
        );
        setHasChanges(true);
      } else {
        if (isRangeOverlapping(startDay, endDay, startHour, endHour)) {
          return;
        } else {
          const newScheduleItem = {
            menuId: selectedMenu.id,
          };
          for (
            let d = Math.min(startDay, endDay);
            d <= Math.max(startDay, endDay);
            d++
          ) {
            const currentDay = daysOfWeek[d];
            newScheduleItem[currentDay] = {
              startTime: `${startHour.toString().padStart(2, "0")}:00`,
              endTime: `${(endHour + 1).toString().padStart(2, "0")}:00`,
            };
          }
          setSchedules([...schedules, newScheduleItem]);
          setHasChanges(true);
        }
      }

      setRangeStart(null);
      setClearMode(false);
    }
  };

  const handleMouseMove = (day, hour) => {
    setHoveredCell({ day, hour });
  };

  const handleSaveMenuSchedule = () => {
    console.log("Saving menu schedule:", schedules);
    setHasChanges(false);

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const transformedData = transformDataByMenu(schedules, timeZone);
    console.log(transformedData);

    const mergedMenus = menus.map((menu) => {
      const matchingSchedule = transformedData.find(
        (schedule) => schedule.id === menu.id
      );

      const menuData = {
        ...menu,
        menu_id: menu.id,
        ...(matchingSchedule ? { schedule: matchingSchedule.schedule } : {}),
      };

      if (!matchingSchedule) {
        delete menuData.schedule;
      }

      return menuData;
    });

    console.log(mergedMenus);
    const errors = [];

    Promise.all(
      mergedMenus.map((updatedMenuInfo) => {
        updatedMenuInfo = {
          ...updatedMenuInfo,
          menu_type: "default",
          background_image_url:
            "https://plus.unsplash.com/premium_photo-1661883237884-263e8de8869b?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        };
        return makeRequest(
          "POST",
          "menu_manager/edit_menu",
          updatedMenuInfo,
          "application/json",
          localStorage.getItem("token"),
          localStorage.getItem("tokenType"),
          () => { }
        ).catch((error) => {
          errors.push(error);
          console.error("Error al guardar el menú:", error);
        });
      })
    )
      .then(() => {
        if (errors.length > 0) {
          console.log("Errores al guardar algunos menús:", errors);
          setNotification({
            type: "error",
            message: `Hubo ${errors.length} error(es) al guardar los menús.`,
          });
        } else {
          console.log("Todos los menús se guardaron correctamente.");
          setNotification({
            type: "success",
            message: "¡Todos los menús se guardaron correctamente!",
          });
        }
        setIsNotificationOpen(true);
      })
  };

  const handleClearSelectedMenu = () => {
    if (!selectedMenu) {
      return;
    }

    setSchedules((prevSchedules) =>
      prevSchedules.filter((schedule) => schedule.menuId !== selectedMenu.id)
    );
    setHasChanges(true);
  };

  const handleClearAllSchedules = () => {
    setSchedules([]);
    setHasChanges(true);
    console.log("clear");
  };

  const isCellPainted = (day, hour) => {
    const time = `${hour.toString().padStart(2, "0")}:00`;
    return schedules.some(
      (schedule) =>
        schedule[day] &&
        schedule[day].startTime <= time &&
        schedule[day].endTime > time
    );
  };

  const formatCellTime = (hour) => {
    const hourFormatted = hour % 12 || 12;
    const amPm = hour < 12 ? "AM" : "PM";
    return `${hourFormatted}:00 ${amPm}`;
  };

  return (
    <TooltipProvider>
      {loading ? (
        menus && menus.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full min-h-[80vh] p-6 bg-white text-gray-800">
            <div className="bg-white p-10 rounded-3xl border border-gray-200 shadow-xl text-center max-w-md w-full transform transition-all hover:scale-105">
              <div className="w-24 h-24 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Aún no tienes menús creados o activados</h2>
              <p className="text-gray-600 mb-8 text-base">
                Para empezar a organizar tu agenda semanal, primero debes crear o activar al menos un menú en la sección "Menú".
              </p>
              <SendButton
                onClick={() => {
                  window.dispatchEvent(new CustomEvent("navigateAdminTab", { detail: { tabName: "Menú" } }));
                  window.dispatchEvent(new CustomEvent("changeAdminTab", { detail: "Menu" })); // Fallback para vista superadmin
                }}
              >
                Ir a Menús
              </SendButton>
            </div>
          </div>
        ) : (
        // CAMBIO: Fondo principal blanco, texto oscuro
        <div className="flex flex-col h-screen p-6 bg-white text-gray-800">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900">
              Agenda Semanal Menus
            </h1>
            {hasChanges && !rangeStart && (
              <div className="fixed bottom-6 right-20 z-50">
                <SendButton
                  onClick={handleSaveMenuSchedule}
                  className="shadow-lg"
                >
                  Guardar Cambios
                </SendButton>
              </div>
            )}
          </div>
          <div className="flex flex-1 gap-6 overflow-auto lg:overflow-visible">
            <div className="flex-1 flex flex-col gap-4 min-w-[800px] min-h-[600px]">
              {/* CAMBIO: Card con fondo blanco y sombra suave */}
              <Card className="bg-white text-gray-800 border-gray-200 shadow-md">
                <CardHeader>
                  <CardTitle>Agenda</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-col gap-4">
                    <div className="flex gap-4">
                      <div className="w-1/2">
                        <Label htmlFor="menu-select">Seleccionar Menu</Label>
                        {/* CAMBIO: Select con fondo blanco y borde gris */}
                        <Select onValueChange={handleMenuSelect}>
                          <SelectTrigger className="w-full text-gray-800 bg-white border-gray-300">
                            <SelectValue
                              placeholder="Selecciona un Menu"
                              className="text-gray-500"
                            >
                              {selectedMenu && (
                                <div className="flex items-center text-gray-800">
                                  <div
                                    className="w-4 h-4 rounded-full mr-2"
                                    style={{
                                      backgroundColor: selectedMenu.color,
                                    }}
                                  ></div>
                                  {selectedMenu.name}
                                </div>
                              )}
                            </SelectValue>
                          </SelectTrigger>
                          {/* CAMBIO: SelectContent con fondo blanco y borde gris */}
                          <SelectContent className="bg-white text-gray-800 border border-gray-300 shadow-lg">
                            {menus.map((menu) => (
                              <SelectItem
                                key={menu.id}
                                value={menu.id.toString()}
                                // CAMBIO: Estilo hover/focus de SelectItem
                                className="focus:bg-gray-100 focus:text-gray-900 text-gray-800 hover:text-gray-900"
                              >
                                <div className="flex items-center">
                                  <div
                                    className="w-4 h-4 rounded-full mr-2"
                                    style={{ backgroundColor: menu.color }}
                                  ></div>
                                  {menu.name}
                                </div>
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="w-1/2">
                        <h3 className="text-sm font-semibold mb-2">
                          Menus Creados
                        </h3>
                        <div className="grid grid-cols-2 gap-x-0.5">
                          {menus.map((menu) => (
                            <div
                              key={menu.id}
                              className="flex items-center space-x-2 mb-1"
                            >
                              <div
                                className="w-4 h-4 rounded-full flex-shrink-0"
                                style={{ backgroundColor: menu.color }}
                              ></div>
                              {/* CAMBIO: Texto de menú oscuro */}
                              <span className="text-sm text-gray-800 truncate">
                                {menu.name}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    {/* Los CloseButton y SendButton ya deberían estar bien debido a refactorizaciones anteriores */}
                    <div className="flex gap-2">
                      <CloseButton
                        onClick={handleClearSelectedMenu}
                        disabled={!selectedMenu}
                      >
                        Borrar Seleccionados
                      </CloseButton>
                      <CloseButton onClick={handleClearAllSchedules}>
                        Borrar Todos
                      </CloseButton>
                    </div>
                  </div>
                </CardContent>
              </Card>
              {/* CAMBIO: Card principal con fondo blanco y sombra suave */}
              <Card className="flex-1 bg-white text-gray-800 border-gray-200 shadow-md overflow-hidden">
                <CardHeader>
                  <CardTitle>Agenda Semanal</CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <div className="overflow-x-auto">
                    <div className="inline-flex min-w-max">
                      {/* CAMBIO: Sticky left con fondo blanco, texto oscuro */}
                      <div className="sticky left-0 z-10 bg-white border-r border-gray-200">
                        <div className="w-24 h-5 border-b border-gray-200"></div>
                        {daysOfWeek.map((day) => (
                          <div
                            key={day}
                            // CAMBIO: Bordes grises y texto tenue oscuro
                            className="h-10 w-24 flex items-center justify-end text-xs text-gray-500 pr-2 border-b border-gray-200"
                          >
                            {day === "Monday"
                              ? "Lunes"
                              : day === "Tuesday"
                                ? "Martes"
                                : day === "Wednesday"
                                  ? "Miercoles"
                                  : day === "Thursday"
                                    ? "Jueves"
                                    : day === "Friday"
                                      ? "Viernes"
                                      : day === "Saturday"
                                        ? "Sabado"
                                        : day === "Sunday"
                                          ? "Domingo"
                                          : ""}
                          </div>
                        ))}
                      </div>
                      <div
                        className="inline-flex flex-col"
                        ref={scheduleGridRef}
                      >
                        <div className="flex">
                          {Array.from({ length: 24 }).map((_, hour) => (
                            <div
                              key={`time-${hour}`}
                              // CAMBIO: Bordes grises y texto tenue oscuro
                              className="w-[3.75rem] h-5 flex items-center justify-center text-[11px] text-gray-500 border-r border-b border-gray-200"
                            >
                              {formatCellTime(hour)}
                            </div>
                          ))}
                        </div>
                        {daysOfWeek.map((day) => (
                          <div key={day} className="flex">
                            {Array.from({ length: 24 }).map((_, hour) => (
                              <div
                                key={`${day}-${hour}`}
                                // CAMBIO: Celdas base blancas con bordes grises
                                className="w-[3.75rem] h-10 border-r border-b border-gray-200 cursor-pointer relative bg-white"
                                style={getScheduleStyle(day, hour)}
                                onClick={() => handleCellClick(day, hour)}
                                onMouseMove={() => handleMouseMove(day, hour)}
                              >
                                {hoveredCell &&
                                  hoveredCell.day === day &&
                                  hoveredCell.hour === hour && (
                                    // CAMBIO: Overlay de hover con fondo gris/negro semitransparente para contraste
                                    <span className="absolute inset-0 flex items-center justify-center text-[9px] font-medium bg-black bg-opacity-10 text-gray-800 select-none">
                                      {formatCellTime(hour)}
                                    </span>
                                  )}
                                {rangeStart &&
                                  rangeStart.day === day &&
                                  rangeStart.hour === hour && (
                                    // CAMBIO: Etiqueta de rango Start con color primario/contraste
                                    <span className="absolute top-0 left-0 bg-blue-600 text-white text-[9px] p-0.5 rounded-br select-none">
                                      {clearMode ? "Clear start" : "Start time"}
                                    </span>
                                  )}
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
        )
      ) : (
        <Box sx={{ height: "100vh" }} />
      )}

      {/* Los CustomDialogs ya deberían usar la paleta clara refactorizada en el paso anterior */}
      <CustomDialog open={showTutorial} onOpenChange={setShowTutorial}>
        <CustomDialogContent className="sm:max-w-[425px] text-gray-800">
          <DialogHeader>
            <CustomDialogTitle>
              Bienvenido a la Agenda Semanal
            </CustomDialogTitle>
            {/* CAMBIO: Texto del Dialog en gris oscuro */}
            <p className="text-gray-700">Aqui tienes una micro guia de como funciona:</p>
          </DialogHeader>
          <div className="py-4">
            <TutorialAnimation />
          </div>
          <DialogFooter>
            <CloseButton onClick={closeTutorial}>Entendido!</CloseButton>
          </DialogFooter>
        </CustomDialogContent>
      </CustomDialog>
      <CustomDialog
        open={isNotificationOpen}
        onOpenChange={setIsNotificationOpen}
      >
        <CustomDialogContent>
          <DialogHeader>
            <CustomDialogTitle className="text-xl font-semibold">
              {notification?.type === "error" ? "Error" : "Success"}
            </CustomDialogTitle>
          </DialogHeader>
          {/* CAMBIO: Texto del cuerpo de la notificación oscuro */}
          <div className="p-4 text-gray-800 text-lg">{notification?.message}</div>
          <DialogFooter>
            <CloseButton onClick={() => setIsNotificationOpen(false)} sx={{
              backgroundColor: "#E0E0E0",
              color: "#424242",
              "&:hover": {
                backgroundColor: "#D5D5D5",
              }
            }}>
              Cerrar
            </CloseButton>
          </DialogFooter>
        </CustomDialogContent>
      </CustomDialog>
    </TooltipProvider>
  );
}